const REQUEST_TYPE_CONTENT_TYPE_MAP = new Map([
    ['binary', 'application/octet-stream'],
    ['json', 'application/json'],
    ['string', 'text/plain'],
]);
function setRequestContentType(headers, requestType) {
    if (requestType && REQUEST_TYPE_CONTENT_TYPE_MAP.has(requestType) && !headers.get('Content-Type')) {
        headers.set('Content-Type', REQUEST_TYPE_CONTENT_TYPE_MAP.get(requestType));
    }
}

export { setRequestContentType };
//# sourceMappingURL=setRequestContentType.mjs.map
